import React from 'react';
import styles from './styles.module.scss';
import cN from 'classnames';
import { useSelector } from 'react-redux';
import { RootState } from '@Redux/search/store';
const dayjs = require('dayjs');

import { ArrowRightIcon, PurchaseIcon } from '@features/ui/Icons';

const PromotionDeal = () => {
    const moduleName = 'purchase';
    const { UrlParams } = useSelector((state: RootState) => state.search);

    const getDestinationHref = () => {
        const from = UrlParams.SeekDestinations[0];
        const to = UrlParams.SeekDestinations[1];
        const fDepDate = new Date(from.DepartDate);
        const tDepDate = new Date(to.DepartDate);
        const time = tDepDate.getTime() - fDepDate.getTime();

        const url = 'https://vacation.liontravel.com/detail_freely/181129004';
        const fDeparture = `${from.DepartCountry}_${from.DepartCity}`;
        const fDestination = `${from.ArriveCountry}_${from.ArriveCity}`;
        const tDeparture = `${to.DepartCountry}_${to.DepartCity}`;
        const tDestination = `${to.ArriveCountry}_${to.ArriveCity}`;
        const fdate = dayjs(`${from.DepartDate}`).format('YYYYMMDD');
        const roomlist = '1-0-0';
        const noTrans = UrlParams.NonStop === false ? '0' : '1';
        const day = time / 1000 / 60 / 60 / 24 + 1;
        const airline = UrlParams.PreferAirlines;

        return `${url}?fDeparture=${fDeparture}&fDestination=${fDestination}&tDeparture=${tDeparture}&tDestination=${tDestination}&fdate=${fdate}&roomlist=${roomlist}&noTrans=${noTrans}&day=${day}&airline=${airline}&webfrom=T`;
    };

    return (
        <div className={cN(moduleName, styles[moduleName])}>
            <div className={styles.title}>
                <PurchaseIcon fill="#3ea5d9" />
            </div>
            <div className={styles.content}>
                同時訂購<span>機票</span>和<span>飯店</span>，還能省更多？
            </div>
            <a
                className={styles.more}
                href={getDestinationHref()}
                target="_blank"
                rel="noreferrer noopener"
            >
                立即前往
                <ArrowRightIcon />
            </a>
        </div>
    );
};

export default PromotionDeal;
